import React, { KeyboardEvent, MouseEvent, ReactNode, useState } from 'react';
import {
  Dialog,
  IconButton,
  Stack,
  Text,
  Box,
  Inline,
  Columns,
  Column,
} from '@origin-digital/ods-core';
import { IconInfo } from '@origin-digital/ods-icons';
import { IEFixedAlert } from '../utils/IEFixedAlert';
import { EVModal } from './generalElectricVehicle';
import { StaticPerkAccordionType } from '../../typings';

interface EVPowerUpPromoboxProps {
  variant?: 'default' | 'open';
}

export const EVPowerUpPromobox: React.FC<EVPowerUpPromoboxProps> = ({ variant = 'default' }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = (e: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowModal(true);
  };

  const moreInfoIconModal = (
    <Box marginLeft="none">
      <Dialog
        id={`ev-promobox-modal`}
        title=""
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        {EVModal}
      </Dialog>
    </Box>
  );

  const ExpandedView = (
    <Stack>
      <Text data-id="ev-promobox-content">
        Origin EV Power Up is available exclusively on this plan – simply add it to your account
        after signing up and access an exclusive 8c/kWh EV charging rate. That could mean less than
        $5 for a full charge.
      </Text>
      <Columns space="none" collapseBelow="xl">
        <Column width="content">
          <Text>How we calculate&nbsp;</Text>
        </Column>
        <Column width="content">
          <Inline space="xxsmall">
            <Text>this cost</Text>
            <IconButton
              data-id="ev-promo-box-modal-trigger-default"
              noIconPadding={true}
              onClick={handleShowModal}
            >
              <IconInfo color="grey300" />
            </IconButton>
          </Inline>
        </Column>
      </Columns>
      {showModal && moreInfoIconModal}
    </Stack>
  );

  return variant === 'open' ? (
    ExpandedView
  ) : (
    <IEFixedAlert
      icon={false}
      tone="caution"
      data-id="ev-promo-box"
      data-testid="ev-promo-box"
      muiProps={{
        style: {
          maxWidth: '100%',
        },
      }}
    >
      <Stack space="xsmall">
        <Columns space="medium">
          <Column>
            <Stack space="xxsmall">
              <Text weight="medium" tone="neutralDark" data-id="ev-promobox-title">
                Exclusive EV rate of 8c/kWh
              </Text>
            </Stack>
          </Column>
          <Column width="content" alignX="right">
            <img
              src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/icons/EV_Power_Up.svg"
              alt="EV power up"
              height="44"
            />
          </Column>
        </Columns>
        {ExpandedView}
      </Stack>
    </IEFixedAlert>
  );
};

const EVPerkBody: ReactNode = <EVPowerUpPromobox variant="open" />;
const EVPerkSummary: ReactNode = <Text weight="medium">Exclusive EV rate of 8c/kWh</Text>;
const EVPerkIcon =
  'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/icons/EV_Power_Up.svg';
const EVPerkId = 'ev-perk-accordion';

export const EVPerkContent: StaticPerkAccordionType = {
  accordionSummary: EVPerkSummary,
  accordionIcon: EVPerkIcon,
  accordionBody: EVPerkBody,
  accordionDataId: EVPerkId,
};
